// TODO 在 index.less 写 @require('~choerodon-ui/dist/choerodon-ui-pro.less'); 无法引入全部样式，没找到问题的原因， 所以只能这样引入
// require('hzero-ui/es/style/index.less'); // TODO 这里最好开启预先加载
require('choerodon-ui/lib/style/themes/default.less');
require('choerodon-ui/lib/style/components.less');
require('choerodon-ui/lib/style/core/index.less');
require('choerodon-ui/lib/style/components-pro.less');
require('hzero-ui/es/badge/style');
require('hzero-ui/es/checkbox/style');
require('hzero-ui/es/form/style');
require('hzero-ui/es/layout/style');
require('hzero-ui/es/notification/style');
require('hzero-ui/es/switch/style');
require('hzero-ui/es/transfer/style');
require('hzero-ui/es/affix/style');
require('hzero-ui/es/breadcrumb/style');
require('hzero-ui/es/col/style');
require('hzero-ui/es/grid/style');
require('hzero-ui/es/list/style');
require('hzero-ui/es/pagination/style');
require('hzero-ui/es/row/style');
require('hzero-ui/es/table/style');
require('hzero-ui/es/tree/style');
require('hzero-ui/es/alert/style');
require('hzero-ui/es/button/style');
require('hzero-ui/es/collapse/style');
require('hzero-ui/es/icon/style');
require('hzero-ui/es/locale-provider/style');
require('hzero-ui/es/popconfirm/style');
require('hzero-ui/es/select/style');
require('hzero-ui/es/tabs/style');
require('hzero-ui/es/tree-select/style');
require('hzero-ui/es/anchor/style');
require('hzero-ui/es/calendar/style');
require('hzero-ui/es/date-picker/style');
require('hzero-ui/es/mention/style');
require('hzero-ui/es/popover/style');
require('hzero-ui/es/slider/style');
require('hzero-ui/es/tag/style');
require('hzero-ui/es/upload/style');
require('hzero-ui/es/auto-complete/style');
require('hzero-ui/es/card/style');
require('hzero-ui/es/divider/style');
require('hzero-ui/es/menu/style');
require('hzero-ui/es/progress/style');
require('hzero-ui/es/spin/style');
require('hzero-ui/es/time-picker/style');
require('hzero-ui/es/version/style');
require('hzero-ui/es/avatar/style');
require('hzero-ui/es/carousel/style');
require('hzero-ui/es/drawer/style');
require('hzero-ui/es/input/style');
require('hzero-ui/es/message/style');
require('hzero-ui/es/radio/style');
require('hzero-ui/es/steps/style');
require('hzero-ui/es/timeline/style');
require('hzero-ui/es/back-top/style');
require('hzero-ui/es/cascader/style');
require('hzero-ui/es/dropdown/style');
require('hzero-ui/es/input-number/style');
require('hzero-ui/es/modal/style');
require('hzero-ui/es/rate/style');
require('hzero-ui/es/tooltip/style');